import React, { forwardRef, useEffect, useState } from "react";
import Input from "./Input";
import { bm_date, parseToTimestamp } from "../utils/Utils";

const DateField = forwardRef(function DateField(
    { value, edit, onChange, ...rest },
    ref
) {
    const [text, setText] = useState("");
    const [lastValid, setLastValid] = useState("");

    const { onBlur: restOnBlur, ...safeRest } = rest;

    useEffect(() => {

        if (!value) {
            setText("");
            setLastValid("");
            return;
        }

        const formatted = bm_date(value);
        setText(formatted);
        setLastValid(formatted);
    }, [value]);

    const handleBlur = (val) => {   

        if (!text) {
            // setText("");
            // setLastValid("");
            setTimeout(() => { onChange?.(""); }, 0)
            restOnBlur?.(val);
            return;
        }
        const ts = parseToTimestamp(text);
        if (ts !== null && bm_date(ts) !== lastValid) {
            setLastValid(bm_date(ts));
            onChange?.(ts);
        } else {
            // last valid - maybe clear? 
            setText(lastValid);
        }
        restOnBlur?.(val);
    };

    return (
        <Input
            {...safeRest}
            ref={ref}
            value={text}
            edit={edit}
            onChange={setText}
            onBlur={handleBlur}
            render={(value) ? lastValid : ""}
        />
    );
});

export default DateField;


// import React, { forwardRef, useEffect, useState, useRef, useImperativeHandle } from "react";
// import Input from "./Input";
// import { bm_date, parseToTimestamp } from "../utils/Utils";

// const DateField = forwardRef(function DateField(
//     { value, edit, route = false, onChange, ...rest },
//     ref
// ) {
//     const [text, setText] = useState("");
//     const [lastValid, setLastValid] = useState("");
//     const [focused, setFocused] = useState(false);
//     const inputRef = useRef(null);

//     const { onBlur: restOnBlur, onFocus: restOnFocus, ...safeRest } = rest;

//     const formatDate = (raw) => {
//         let val = raw;
//         if (val.length >= 2) {
//             val = val.substring(0, 2) + "/" + val.substring(2);
//         }
//         if (val.length >= 5) {
//             val = val.substring(0, 5) + "/" + val.substring(5);
//         }
//         return val;
//     };

//     const extractDigits = (formatted) => {
//         return formatted.replace(/\D/g, "").slice(0, 6);
//     };

//     // sync with external value
//     useEffect(() => {
//         if (!value) {
//             setText("");
//             setLastValid("");
//             return;
//         }
//         const formatted = bm_date(value, "MM/DD/YY");
//         const raw = extractDigits(formatted);
//         setLastValid(bm_date(value)); // pretty format
//         setText(raw); // raw digits for editable
//     }, [value]);

//     const handleChange = (newValue) => {
//         const newRaw = newValue.replace(/\D/g, "").slice(0, 6);
//         setText(newRaw);
//     };

//     const handleKeyDown = (e) => {
//         if (e.key !== "Backspace") return;
//         const pos = e.target.selectionStart;
//         const val = e.target.value;
//         if (pos <= 0 || val.charAt(pos - 1) !== "/") return;
//         e.preventDefault();
//     let newText;
//     const slashPos = pos - 1;
//         if (slashPos === 2) {
//             // first slash, remove raw[1]
//             newText = text.slice(0, 1) + text.slice(2);
//         } else {
//             // second slash, remove raw[3]
//             const removeIdx = 3;
//             newText = text.slice(0, removeIdx) + text.slice(removeIdx + 1);
//         }
//         setText(newText);
//         const newPos = pos - 2;
//         setTimeout(() => {
//             inputRef.current?.setSelectionRange(newPos, newPos);
//         }, 0);
//     };

//     const handleBlur = (e) => {
//         if (route && window.bm_state.value !== route) {
//             return;
//         }

//         setFocused(false);

//         if (!text) {
//             onChange?.("");
//             restOnBlur?.(e);
//             return;
//         }

//         const formatted = formatDate(text);
//         const ts = parseToTimestamp(formatted);
//         if (ts !== null) {
//             setLastValid(bm_date(ts));
//             setText(extractDigits(bm_date(ts, "MM/DD/YY")));
//             onChange?.(ts);
//         } else {

//             const revertFormatted = bm_date(value, "MM/DD/YY");
//             setText(extractDigits(revertFormatted));
//         }

//         restOnBlur?.(e);
//     };

//     const handleFocus = (e) => {
//         setFocused(true);
//         restOnFocus?.(e);
//     };

//     useImperativeHandle(ref, () => inputRef.current);

//     return (
//         <Input
//             {...safeRest}
//             ref={inputRef}
//             value={focused ? formatDate(text) : lastValid}
//             edit={edit}
//             onChange={handleChange}
//             onBackSpace={handleKeyDown}
//             onBlur={handleBlur}
//             onFocus={handleFocus}
//         />
//     );
// });

// export default DateField;